import { LinkCardEntry } from "./Types";

export const workHistory: LinkCardEntry[] = [
  {
    imgPath: process.env.PUBLIC_URL + "/images/White1stEdgeLogo.avif",
    title: "Junior Software Engineer, Jan 31, 2023 - May 6, 2025",
    text: "My primary responsibilities included building applications and tools, developing software for our customers, and solving difficult software problems. I was expected to be a collaborator, learn from others, and share my knowledge about software and best practices with my coworkers. I developed a Python CLI tool to generate data for training AI models and worked with a team to build in-depth web interfaces to showcase our work to potential customers and provide value for our existing customers.",
    imgAlt: "1st Edge Logo",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/clearFunctionLogo.svg",
    title: "Software Developer Intern, 23, 2022 - July 22, 2022",
    text: "My responsibilities included developing, restructuring, and improving software for various companies. I collaborated with co-workers and company owners for a clear understanding of product requirements. I worked on a TypeScript-based client application that integrated with a .NET 6-based microservice hosted in Azure with an Azure SQL backend. The microservice coordinated a background job that worked with other external APIs.",
    imgAlt: "Clear Function Logo",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/FreedHardemanUniversityLogo.png",
    title: "Tech Support Assistant, August 2020 - December 2022",
    text: "My responsibilities included running slides, audio maintenance, sound mixing, and video presentations for live university events. Also, I was responsible for equipment setup, operation, and maintenance. Additionally, I worked with the IT Help Desk support logging calls and deploying resources.",
    imgAlt: "Freed-Hardeman University Logo",
  },
];

export const ReligiousResourcesEntries: LinkCardEntry[] = [
  {
    imgPath: process.env.PUBLIC_URL + "/images/WVBSLogo.png",
    text: "WVBS is an online School curriculum that covers every book of the Bible, plus a handful of additional subjects. All courses are studied at-your-own-pace, on your schedule, with no official start time, end time or duration. They also produce video content available to anyone. I recommend this curriculum for individuals seeking a thorough understanding of the scriptures.",
    imgAlt: "World Video Bible School Logo",
    linkPath: "https://wvbs.org/",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/APLogo.svg",
    text: "For more than 40 years Apologetics Press has published and disseminated materials for self study, group study, or evangelistic purposes. Topics range from evidences supporting the Christian Faith to highly controversial areas that challenge that Faith. This source can help those seeking understanding about how science coincides with the Bible.",
    imgAlt: "Apologetics Press Logo",
    linkPath: "https://apologeticspress.org/",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/CPCofCLogo.avif",
    text: "The Chase Park Church of Christ is a growing, Bible-centered, and friendly church. The Chase Park congregation endeavors to simply follow the New Testament pattern for the Lord's church. Chase Park is a family of brothers and sisters in Christ who share a gift of love, strength, joy, and hope. Check out the 'Finding My Faith' > 'What Must I do to be Saved' page to learn God's plan for salvation.",
    title: "Chase Park Church of Christ",
    imgAlt: "Chase Park Church of Christ Logo",
    linkPath: "https://www.cpcofc.org/",
  },
];

export const ReligiousToolsEntries: LinkCardEntry[] = [
  {
    imgPath: process.env.PUBLIC_URL + "/images/BLBLogo.svg",
    text: "Blue Letter Bible provides powerful tools for an in-depth study of God's Word through a free online reference library, with study tools that are grounded in the historical, conservative Christian faith. Blue Letter Bible can be used to search the scriptures for key words, dive into the original Greek and Hebrew, and much more.",
    title: "Blue Letter Bible",
    imgAlt: "Blue Letter Bible Logo",
    linkPath: "https://www.blueletterbible.org/",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/bibleMemoryLogo.png",
    text: "The Bible Memory App is a complete Bible memory system that makes it easy for you to Memorize, Organize, and Review verses. I have found this website to be helpful when trying to memorize key passages from God's word.",
    imgAlt: "Bible Memory .com Logo",
    linkPath: "https://www.cpcofc.org/",
  },
];

export const EducationEntries: LinkCardEntry[] = [
  {
    imgPath:
      process.env.PUBLIC_URL + "/images/CalhounCommunityCollegeLogo.svg.png",
    text: "Calhoun Community College is a two-year college that aims to teach and serve as the region's leader in education and workforce development. I attended Calhoun for four semesters: two while dual enrolling as a high school senior, and two as a college freshman. I completed my introductory College courses and most of my liberal arts core at Calhoun before transferring to a four-year university.",
    imgAlt: "Calhoun Community College Logo",
    linkPath: "https://calhoun.edu/",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/FreedHardemanUniversityLogo.png",
    text: "Freed-Hardeman University is an academic community, associated with churches of Christ, which is dedicated to providing excellent undergraduate, graduate, and professional programs. I attended Freed-Hardeman University for five semesters and graduated with a bachelor's in computer science with an emphasis in software engineering.",
    imgAlt: "Freed-Hardeman University Logo",
    linkPath: "https://fhu.edu/",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/WVBSLogo.png",
    text: "WVBS is an online School curriculum that covers every book of the Bible, plus a handful of additional subjects. All courses are studied at-your-own-pace, on your schedule, with no official start time, end time or duration. I have completed eight of the courses and have thoroughly enjoyed studying the content. Furthermore, I appreciate the flexibility I have to decide when to study.",
    imgAlt: "World Video Bible School Logo",
    linkPath: "https://school.wvbs.org/",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/gatechLogo.png",
    text: "The Georgia Institute of Technology is one of the nation's top public research universities with more than 50,000 students who study in person at the main campus in Atlanta, at off-campus instructional sites such as Georgia Tech-Europe in France, and through distance and online learning. I intend to study for a master's degree at Georgia Tech with a focus on human-computer interaction.",
    imgAlt: "Georgia Tech Logo",
    linkPath: "https://www.gatech.edu/",
  },
];

export const CreativeHobbiesEntries: LinkCardEntry[] = [
  {
    imgPath: process.env.PUBLIC_URL + "/images/CardCreatorLogo.svg",
    title: "Card Game Creation",
    text: "One of my favorite hobbies is creating card games. Since middle school, I have been creating card games, researching and experimenting with card game mechanics. Someday, I'd like to design my own official trading card game. Card Creator is a super useful tool for the card designing process that I use.",
    imgAlt: "Card Creator Logo",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/PerlerLogo.png",
    title: "Perler Beads",
    text: "Making pixel art with perler beads is another one of my hobbies. I find it relaxing to make Pokémon, animals, and other video game characters.",
    imgAlt: "My Perler Bead Creations",
  },
  {
    imgPath: process.env.PUBLIC_URL + "/images/UnrealEngineLogo.svg.png",
    title: "Game Development",
    text: "Ever since I was little, I've loved designing my own games. I've made a game called “Lost Things” by using Lego assets in Unity, and I've also been learning to develop in Unreal. Someday, I hope to release my own indie game.",
    imgAlt: "Unreal Engine Logo",
    linkPath:
      "https://play.unity.com/en/games/cd4681c2-c507-45ad-a52e-cff69e979f14/lost-things",
    clickMessageOverrideText: "Click here to play 'Lost Things.'",
  },
];
